import {BaseControl} from '../controls';
import {FilterControlInterface} from '../../interfaces';

import {Helper} from './helper';

export class FilterControl {
    public name: string;
    public placeholder: string;
    public shown: boolean;
    public controls: BaseControl[];
    public sortIndex: number;
    public isRemovable: boolean;
    public block: boolean;

    constructor(data: FilterControlInterface) {
        this.name = data.name;
        this.placeholder = Helper.getCapitalized(data.placeholder);
        this.shown = (typeof data.shown !== 'undefined') ? data.shown : false;
        this.controls = data.controls;
        this.sortIndex = data.sortIndex;
        this.isRemovable = !data.isRemovable ? true : data.isRemovable;
        this.block = data.block || false;
    }

    getControlByName(controlName: string): BaseControl {
        const filteredControls = this.controls.filter((control: BaseControl) => control.name === controlName);

        if (filteredControls.length > 0) {
            return filteredControls[0];
        }

        return null;
    }

    setControlValueByName(name: string, value: string | number): void {
        const formsControl = this.getControlByName(name);

        if (formsControl) {
            formsControl.value = value;
        }
    }

    resetControlByName(controlName: string): void {
        const filteredControls = this.controls.filter((control: BaseControl) => control.name = controlName);

        if (filteredControls.length > 0) {
            filteredControls[0].resetValue(false);
        }
    }

    resetControls(): void {
        this.controls.map((control: BaseControl) => !control.disabled && control.resetValue(false));
    }
}
